import { AxiosResponse } from "axios";
import { useRequest } from "hooks/useRequest";

export const useForecastModifierConfigRequester = () => {
	const request = useRequest("ForecastModifierConfigs");

	return {
		...request,
		deleteModifiers: (value: number[]) => {
			return request
				.POST("delete", value)
				.then((res: AxiosResponse<any>) => {
					return res.data;
				});
		},
	};
};
